var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallRecBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2562 0.261719H1.78512C0.799228 0.261719 0 1.06095 0 2.04684C0 3.03274 0.799228 3.83197 1.78512 3.83197H17.2562C18.2421 3.83197 19.0413 3.03274 19.0413 2.04684C19.0413 1.06095 18.2421 0.261719 17.2562 0.261719Z",
    fill: "#B4DAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRecBottom);
export default __webpack_public_path__ + "static/media/smallRecBottom.c154dc76141ce2962e6471fb15766a0c.svg";
export { ForwardRef as ReactComponent };